"use client";

import { t } from "@/lib/localization";
import { QuizQuestion, QuizQuestionType } from "@/lib/utils/lomdaV3/types";
import { quizType } from "../../../lib/blockRegistry";
import { useLomdaLocale } from "../../../hooks/useLomdaLocale";
import { DraftTextarea, nonBlank } from "../shared/draftTextarea";

const INSTRUCTION_KEY: Record<QuizQuestionType, string> = {
    single: "lomda-v3-editor.quiz.instr-single",
    multiple: "lomda-v3-editor.quiz.instr-multiple",
    "true-false": "lomda-v3-editor.quiz.instr-true-false",
    open: "lomda-v3-editor.quiz.instr-open",
};

const textClass =
    "lomda-v3-text-small whitespace-pre-wrap break-words text-[hsl(var(--lomda-muted-text))]";

function useDefaultInstruction(question: QuizQuestion): string {
    const locale = useLomdaLocale();
    return t(INSTRUCTION_KEY[quizType(question)], locale);
}

export function QuizInstruction({ question }: { question: QuizQuestion }) {
    const fallback = useDefaultInstruction(question);
    if (question.hideInstruction) return null;
    return (
        <p className={textClass}>
            {nonBlank(question.instruction)?.trim() ?? fallback}
        </p>
    );
}

export function QuizInstructionInput({
    question,
    onChange,
}: {
    question: QuizQuestion;
    onChange: (instruction: string | undefined) => void;
}) {
    const fallback = useDefaultInstruction(question);
    if (question.hideInstruction) return null;
    return (
        <DraftTextarea
            value={question.instruction}
            onCommit={onChange}
            placeholder={fallback}
            aria-label={t("lomda-v3-editor.quiz.instruction")}
            className={textClass}
        />
    );
}
